import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';

// Sayfa bazlı code-splitting: ana sayfa eager, diğer rotalar lazy chunk.
// Böylece ilk yüklemede indirilen ve parse edilen JS önemli ölçüde küçülür.
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const ServiceDetail = lazy(() => import('./pages/ServiceDetail'));
const DistrictDetail = lazy(() => import('./pages/DistrictDetail'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const KnowledgeBase = lazy(() => import('./pages/KnowledgeBase'));
const GuideDetail = lazy(() => import('./pages/GuideDetail'));
const GuideCategory = lazy(() => import('./pages/GuideCategory'));

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

const PageFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="text-primary text-lg font-semibold">Yükleniyor…</div>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
      <SpeedInsights />
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/kepenk-servisi" element={<ServiceDetail service="kepenk-servisi" />} />
            <Route path="/kepenk-tamiri" element={<ServiceDetail service="kepenk-tamiri" />} />
            <Route path="/otomatik-kepenk" element={<ServiceDetail service="otomatik-kepenk" />} />
            <Route path="/acil-kepenk-tamiri" element={<ServiceDetail service="acil-kepenk-tamiri" />} />
            <Route path="/7-24-kepenk-tamiri" element={<Navigate to="/acil-kepenk-tamiri" replace />} />
            <Route path="/acil-kepenk" element={<Navigate to="/acil-kepenk-tamiri" replace />} />
            <Route path="/sifir-kepenk" element={<ServiceDetail service="sifir-kepenk" />} />
            <Route path="/kepenk-parcalari" element={<ServiceDetail service="kepenk-parcalari" />} />
            <Route path="/:district" element={<DistrictDetail />} />

            {/* Bilgi Merkezi Rotaları */}
            <Route path="/bilgi-merkezi" element={<KnowledgeBase />} />
            <Route path="/bilgi-merkezi/rehber/:slug" element={<GuideDetail />} />
            <Route path="/bilgi-merkezi/kategori/:categoryId" element={<GuideCategory />} />
          </Routes>
        </Suspense>
      </Layout>
      <Analytics />
    </Router>
  );
}

export default App;
